import * as React from 'react'

import useIncidenceFilters, {
  DefaultParams,
  UseIncidenceFilterReturn,
} from 'modules/bookkeepers/hooks/useIncidenceFilters'

const MessageFilterContext = React.createContext<UseIncidenceFilterReturn | null>(null)

interface MessageFilterProviderProps {
  defaultFilterValues: DefaultParams
}

export const MessageFilterProvider = ({
  defaultFilterValues,
  children,
}: React.PropsWithChildren<MessageFilterProviderProps>) => {
  const filters = useIncidenceFilters(defaultFilterValues)

  return <MessageFilterContext.Provider value={filters}>{children}</MessageFilterContext.Provider>
}

export const useMessageFilterContext = (): UseIncidenceFilterReturn => {
  const filters = React.useContext(MessageFilterContext)

  if (!filters) {
    throw new Error('useMessageFilterContext must be used within a IncidenceFilterProvider')
  }

  return filters
}
